import { Grid, Group, Layout, Page } from "@/comn/components";
import {
    APIS,
    PGEUIDS,
    SF_AUTH_DTL,
    SG_AUTH_MENU_LIST,
    URLS,
} from "@/tra/tancis/ptli/ptl/authmenu/services/PtliAuthMenuService";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import React, { useEffect } from "react";
import { comnUtils } from "@/comn/utils";
import { useNavigate, useParams } from "react-router-dom";
import { PTLI1015003Q } from "@/tra/tancis/ptli/ptl/authmenu/PTLI1015003Q";
import { PTLI1015004Q } from "@/tra/tancis/ptli/ptl/authmenu/PTLI1015004Q";

/*
 * Save Auth and Menu Link
 * !== 권한 및 메뉴 연결 저장 ==!
 */
export const PTLI1015002S = () => {
    const { pgeUid } = usePage();
    const { authId } = useParams();
    const modal = useModal();
    const toast = useToast();
    const navigate = useNavigate();
    const { getStore, setStore } = useStore({ pgeUid: pgeUid });

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0052" },
        ],
    });

    const form = { authDtl: useForm({ defaultSchema: SF_AUTH_DTL }) };

    const grid = { authMenuList: useGrid({ defaultSchema: SG_AUTH_MENU_LIST }) };

    const fetch = {
        getAuthDtl: useFetch({
            api: (data: any) => APIS.getAuthMenuDtl(data),
            onSuccess: (data: any) => {
                const { content } = data.authMenuDtl;
                if (comnUtils.isEmpty(content)) {
                    modal.openModal({ content: "msg.ptl.00694" }); // Abnormal access. !== 비정상 접근입니다. ==!
                    handler.onListBtnClick();
                }

                form.authDtl.setValues(content);
                grid.authMenuList.setData({ content: content.cnctList });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        saveAuthMenuDtl: useFetch({
            api: () =>
                APIS.saveAuthMenuDtl({
                    ...form.authDtl.getValues(),
                    cnctList: grid.authMenuList.getData({ excludes: ["origin"] }),
                }),
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00062" }); // 정상적으로 저장되었습니다.
                handler.onListBtnClick();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00026" }), // 저장이 실패하였습니다.
        }),
    };

    const handler = {
        onGridAddBtnClick: () => {
            const modalCallback = (list: any[]) => {
                if (!comnUtils.isEmpty(list)) {
                    list.forEach((item: any) => grid.authMenuList.addRow({ ...item, authId: authId }));
                }
                modal.closeModal();
            };

            modal.openModal({
                draggable: true,
                size: "md",
                content: (
                    <PTLI1015003Q
                        authId={authId}
                        bsopClsfCd={form.authDtl.getValue("bsopClsfCd")}
                        ptlTpCd={form.authDtl.getValue("ptlTpCd")}
                        callback={modalCallback}
                        authMenuList={grid.authMenuList.getData()}
                    />
                ),
            });
        },
        onGridDelBtnClick: () => {
            if (!grid.authMenuList.isChecked()) {
                modal.openModal({ content: "msg.ptl.00683" }); // Please select a destination to delete. !== 삭제대상을 선택하세요. ==!
                return;
            }
            modal.openModal({
                content: "msg.com.00049",
                onConfirm: () => {
                    grid.authMenuList.deleteRow("checkbox");
                },
            });
        },
        onSaveBtnClick: form.authDtl.handleSubmit(
            () => {
                modal.openModal({
                    content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                    onConfirm: () => fetch.saveAuthMenuDtl.fetch(),
                });
            },
            () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),
        onListBtnClick: () => navigate(`${URLS.ptli1015001q}`),
    };

    useEffect(() => {
        form.authDtl.setEditable("bsopClsfCd", false);
        form.authDtl.setEditable("ptlTpCd", false);

        const mainStore = getStore(PGEUIDS.ptli1015001q);
        if (comnUtils.isEmpty(mainStore) || comnUtils.isEmpty(mainStore.param)) {
            modal.openModal({ content: "msg.ptl.00694" }); // Abnormal access. !== 비정상 접근입니다. ==!
            handler.onListBtnClick();
            return;
        }

        fetch.getAuthDtl.fetch(mainStore.param);

        return () => {
            const { param, ...rest } = mainStore;
            setStore(PGEUIDS.ptli1015001q, rest);
            setStore(PGEUIDS.ptli1015003q, null);
        };
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.authDtl.schema.bsopClsfCd} />
                            <Group.Control {...form.authDtl.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.authDtl.schema.authId} />
                            <Group.Control {...form.authDtl.schema.authNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.authDtl.schema.authDesc} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button role={"gridAdd"} onClick={handler.onGridAddBtnClick} />
                                <Layout.Button role={"gridDelete"} onClick={handler.onGridDelBtnClick} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                    <Group.Section>
                        <Grid {...grid.authMenuList.grid}/>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
